import { jsxs as d, jsx as o } from "@emotion/react/jsx-runtime";
import { useCallback as s, useMemo as b, useEffect as I, Fragment as L } from "react";
import { getPageNumbers as z, DEFAULT_NUMBER_PAGE_TO_DISPLAY as B } from "./helpers.js";
import { StyledContainer as E, PreviousIconsContainer as F, OverrideButton as a, PageNumbersContainer as A, StyledIconContainer as M, OverridePageButton as R, NextIconsContainer as _ } from "./Pagination.styled.js";
import { FontAwesomeIconsPartooUsed as n } from "../../types/components/icon.js";
import { Icon as e } from "../Icon/index.js";
import { Text as D } from "../Text/index.js";
const N = ({
  disabled: l = !1,
  page: i,
  pageCount: c,
  onChange: r,
  className: m,
  dataTrackId: P
}) => {
  const f = c > B, x = s(() => {
    r(1);
  }, [r]), y = s(() => {
    r(c);
  }, [r, c]), v = s(() => {
    r(i + 1);
  }, [r, i]), k = s(() => {
    r(i - 1);
  }, [r, i]), h = b(() => [...z(i, c)], [i, c]), S = s((t) => () => {
    r(t);
  }, [r]);
  return I(() => {
    i < 1 && r(1), i > c && r(c);
  }, [i, c, r]), /* @__PURE__ */ d(E, { className: m, "data-track": P, children: [
    f && /* @__PURE__ */ d(F, { children: [
      /* @__PURE__ */ o(a, { "aria-label": "First", "aria-disabled": i <= 1 || l, onClick: x, children: /* @__PURE__ */ o(e, { icon: [n.faChevronsLeft], iconSize: "16px", color: "secondary" }) }),
      /* @__PURE__ */ o(a, { "aria-label": "Back", "aria-disabled": i <= 1 || l, onClick: k, children: /* @__PURE__ */ o(e, { icon: [n.faChevronLeft], iconSize: "16px", color: "secondary" }) })
    ] }),
    /* @__PURE__ */ o(A, { children: h.map((t, T) => /* @__PURE__ */ o(L, { children: t === -1 ? /* @__PURE__ */ o(M, { "aria-disabled": l, children: /* @__PURE__ */ o(e, { icon: [n.faEllipsis], iconSize: "14px" }) }) : /* @__PURE__ */ o(R, { "aria-label": `Page ${t}`, "aria-current": t === i, "aria-disabled": l, onClick: typeof t == "number" ? S(t) : void 0, type: "button", children: /* @__PURE__ */ o(D, { variant: t === i ? "bodyMBold" : "bodyMRegular", color: t === i ? "theme" : "default", children: t }) }) }, `pagination-page-${T}`)) }),
    f && /* @__PURE__ */ d(_, { children: [
      /* @__PURE__ */ o(a, { "aria-label": "Next", "aria-disabled": i >= c || l, onClick: v, children: /* @__PURE__ */ o(e, { icon: [n.faChevronRight], iconSize: "16px", color: "secondary" }) }),
      /* @__PURE__ */ o(a, { "aria-label": "Last", "aria-disabled": i >= c || l, onClick: y, children: /* @__PURE__ */ o(e, { icon: [n.faChevronsRight], iconSize: "16px", color: "secondary" }) })
    ] })
  ] });
};
export {
  N as Pagination
};
